(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7692],{

/***/ 50891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
}), 'Email');
exports.Z = _default;

/***/ }),

/***/ 85731:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));
var _jsxRuntime = __webpack_require__(85893);
var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
}), 'PhoneIphone');
exports.Z = _default;

/***/ }),

/***/ 37304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* binding */ getAgents; }
});

// UNUSED EXPORTS: getAgent

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/agent.endpoint.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AgentStatic;

(function (AgentStatic) {
  AgentStatic["AgenciesList"] = "/v2/agents";
})(AgentStatic || (AgentStatic = {}));

var AgentDynamic = {
  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description get Agent details
   */
  AgentDetail: function AgentDetail(AgentID) {
    return "/v2/agents/".concat(AgentID);
  }
};
var agent_endpoint_AgentEndpoints = _objectSpread(_objectSpread({}, AgentDynamic), AgentStatic);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/agent.request.ts


var getAgents = function getAgents(filters) {
  return (0,base_services_request/* getRequest */.A_)(agent_endpoint_AgentEndpoints.AgenciesList, filters).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  });
};
var getAgent = function getAgent(id) {
  return getRequest(AgentEndpoints.AgentDetail(id)).then(function (response) {
    return response === null || response === void 0 ? void 0 : response.data;
  })["catch"](function (error) {
    return error.response;
  });
};

/***/ }),

/***/ 71986:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _params_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toArray.js
var toArray = __webpack_require__(83618);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./shared/components/buy-sell-filter/index.tsx + 1 modules
var buy_sell_filter = __webpack_require__(97814);
// EXTERNAL MODULE: ./shared/components/header-title-profile/index.tsx
var header_title_profile = __webpack_require__(50408);
// EXTERNAL MODULE: ./shared/models/const/placeholder-images.const.ts
var placeholder_images_const = __webpack_require__(72020);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Email.js
var Email = __webpack_require__(50891);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PhoneIphone.js
var PhoneIphone = __webpack_require__(85731);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
// EXTERNAL MODULE: ./shared/components/contact-agent-dialog/index.tsx
var contact_agent_dialog = __webpack_require__(21689);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/hooks/useEventGa.hook.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function useEventGa() {
  var event = react.useCallback(function (name_event, info) {
    if ( true && typeof window.gtag !== "undefined") {
      window.gtag("event", name_event, _objectSpread({}, info));
    } else {
      console.log("window.gtag is undefined");
    }
  }, []);
  return {
    event: event
  };
}

/* harmony default export */ var useEventGa_hook = (useEventGa);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agency-profile/components/contact-section/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












function ContactSection(props) {
  var _ref, _ref2, _profileInfo$mobile, _ref3, _ref4, _profileInfo$mobile2;

  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var profileInfo = props.profileInfo,
      _props$isAgency = props.isAgency,
      isAgency = _props$isAgency === void 0 ? false : _props$isAgency;

  var _useEventGa = useEventGa_hook(),
      event = _useEventGa.event;

  var translation = (0,next_intl_cjs_production_min.useTranslations)("agentProfile.profile");

  var handleClose = function handleClose() {
    event("prueba-agencia", {
      event_category: "prueba-agencia",
      event_label: "prueba-agencia",
      value: "prueba-agencia"
    });
    setOpen(!open);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xl: 4,
    lg: 3,
    md: 5,
    sm: 6,
    xs: 12,
    sx: {
      margin: "auto"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ContactInfoContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContactInfoText, null, translation("contact")), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentInfo, {
    className: "--Contacts"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Info, {
    className: "--description --contact"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Email/* default */.Z, null), " ", (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: "mailto:".concat(profileInfo.email)
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, profileInfo.email))), (0,emotion_react_browser_esm/* jsx */.tZ)(Info, {
    className: "--description --contact"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(PhoneIphone/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: "tel:".concat((_ref = (_ref2 = (_profileInfo$mobile = profileInfo.mobile) !== null && _profileInfo$mobile !== void 0 ? _profileInfo$mobile : profileInfo.phone) !== null && _ref2 !== void 0 ? _ref2 : profileInfo.phone2) !== null && _ref !== void 0 ? _ref : "-")
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, (_ref3 = (_ref4 = (_profileInfo$mobile2 = profileInfo.mobile) !== null && _profileInfo$mobile2 !== void 0 ? _profileInfo$mobile2 : profileInfo.phone) !== null && _ref4 !== void 0 ? _ref4 : profileInfo.phone2) !== null && _ref3 !== void 0 ? _ref3 : "-")))), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerButton, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    passHref: true,
    href: "https://wa.me/1".concat(profileInfo.phone, "?text=Hola+estimado(a),+me+interesa+hacer+negocios")
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    target: "_blank",
    bg: "--color-brand-green-main",
    component: "a",
    className: "whatsapp-agencia"
  }, "WHATSAPP ", profileInfo.phone)), (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    bg: "--color-brand-grey-secondary",
    component: "a",
    onClick: handleClose
  }, translation("sendMessage")))), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_agent_dialog/* default */.Z, {
    open: open,
    onClose: handleClose,
    entity_info: profileInfo,
    isAgency: isAgency,
    customClass: "agency"
  }));
}

/* harmony default export */ var contact_section = (ContactSection);

var ContactInfoContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1p9pvm55"
} : 0)( true ? {
  name: "rccfl2",
  styles: "justify-self:flex-end;margin-left:auto;@media screen and (max-width: 991px){margin-right:0;}@media screen and (max-width: 767px){margin-right:auto;}"
} : 0);

var ContactInfoText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1p9pvm54"
} : 0)( true ? {
  name: "12qngrf",
  styles: "font-size:1rem;font-weight:600;color:#262b30;border-top:1px solid #CBCBCB;border-bottom:1px solid #CBCBCB;padding:15px 20px;margin-bottom:20px;text-align:center"
} : 0);

var ContainerButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1p9pvm53"
} : 0)( true ? {
  name: "1sz6ain",
  styles: "display:flex;flex-direction:column;align-items:center;justify-content:center;a{margin:5px 0px;min-width:255px;}"
} : 0);

var ContentInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1p9pvm52"
} : 0)( true ? {
  name: "tkmsje",
  styles: "list-style:none;@media screen and (max-width: 767px){margin-bottom:20px;}&.--Contacts{margin-bottom:20px;& span{width:90%;margin:auto;display:flex;& svg{padding-right:5px;}a{width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}}}"
} : 0);

var Info = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1p9pvm51"
} : 0)( true ? {
  name: "v0ghfj",
  styles: "display:block;font-size:1.063rem;font-weight:500;color:var(--color-brand-blue-main);vertical-align:middle;&.--description{white-space:nowrap;span{font-family:\"Arial\";vertical-align:middle;color:var(--color-brand-grey-secondary);}svg{color:var(--color-brand-grey-secondary);}&.--contact{margin-top:10px;}}"
} : 0);

var AgencyImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1p9pvm50"
} : 0)( true ? {
  name: "a938x5",
  styles: "img{max-width:191px;width:100%;}@media screen and (max-width: 767px){width:158px;text-align:center;margin:auto;}"
} : 0);
// EXTERNAL MODULE: ./shared/components-pages/proyectos/PropertiesSlider.tsx
var PropertiesSlider = __webpack_require__(42979);
// EXTERNAL MODULE: ./shared/components/slider-collection-property/index.tsx
var slider_collection_property = __webpack_require__(2098);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/agent.request.ts + 1 modules
var agent_request = __webpack_require__(37304);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
;// CONCATENATED MODULE: ./shared/components/agent-card-large/index.tsx


function agent_card_large_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







var Icons = {
  Instagram: "/icons/instagram_icon_gray.svg",
  WhatsApp: "/icons/whatsapp_icon_gray.svg",
  Twitter: "/icons/x_icon_gray.svg",
  Facebook: "/icons/facebook_icon_gray.svg"
};

var genUrl = function genUrl(red, value) {
  if (red == "WhatsApp") {
    return "https://wa.me/1".concat(value, "?text=Me+interesa+hacer+negorcios");
  } else {
    return value;
  }
};

function AgentCardLarge(props) {
  var _ref, _ref2, _ref3, _ref4, _ref5, _props$mobile;

  return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.agent_detail */.K.es.agent_detail({
      name: props.name,
      id: props.id
    })
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Card, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardImg, {
    src: props.picture,
    variant: "square",
    alt: props.name
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(CardContentDetail, null, (0,emotion_react_browser_esm/* jsx */.tZ)(AgentName, null, props.name), (0,emotion_react_browser_esm/* jsx */.tZ)(CarContainerDetail, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CarDetailItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, null, "Tel\xE9fono"), (0,emotion_react_browser_esm/* jsx */.tZ)(ItemRef, {
    passHref: true,
    href: (_ref = (_ref2 = (_ref3 = "tel:" + props.mobile) !== null && _ref3 !== void 0 ? _ref3 : props.phone) !== null && _ref2 !== void 0 ? _ref2 : props.phone2) !== null && _ref !== void 0 ? _ref : "-"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", null, (_ref4 = (_ref5 = (_props$mobile = props.mobile) !== null && _props$mobile !== void 0 ? _props$mobile : props.phone) !== null && _ref5 !== void 0 ? _ref5 : props.phone2) !== null && _ref4 !== void 0 ? _ref4 : "-"))), (0,emotion_react_browser_esm/* jsx */.tZ)(CarDetailItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemLabel, null, "Correo"), (0,emotion_react_browser_esm/* jsx */.tZ)(ItemRef, {
    passHref: true,
    href: "mailto:" + props.email
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", null, props.email)))), (0,emotion_react_browser_esm/* jsx */.tZ)(CardContentSocialNetwork, null, props.social_networks.map(function (sn, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: genUrl(sn.name, sn.address),
      target: "_blank",
      passHref: true,
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", null, (0,emotion_react_browser_esm/* jsx */.tZ)("img", {
      src: Icons[sn.name],
      alt: "".concat(Icons[sn.name], " Icon"),
      width: 30,
      height: 30
    })));
  })))));
}

/* harmony default export */ var agent_card_large = (AgentCardLarge);

var Card = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "ed82sm69"
} : 0)( true ? {
  name: "1emt0ed",
  styles: "width:100%;max-width:290px;border-radius:15px;background-color:var(--color-brand-bg-secondary);overflow:hidden;display:inline-block;min-height:415px;max-height:415px;@media screen and (max-width: 500px){}"
} : 0);

var CardImg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Avatar/* default */.Z,  true ? {
  target: "ed82sm68"
} : 0)( true ? {
  name: "nkp98k",
  styles: "width:100%;height:200px;object-fit:contain"
} : 0);

var CardContentDetail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed82sm67"
} : 0)( true ? {
  name: "x1kg67",
  styles: "padding:20px 25px"
} : 0);

var AgentName = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "ed82sm66"
} : 0)( true ? {
  name: "1qccwt1",
  styles: "font-size:1.163rem;font-weight:700;text-align:left;color:var(--color-brand-blue-main)"
} : 0);

var CarContainerDetail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ed82sm65"
} : 0)( true ? {
  name: "wo9ozq",
  styles: "width:100%;list-style:none"
} : 0);

var CarDetailItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ed82sm64"
} : 0)( true ? {
  name: "1xpvzbk",
  styles: "display:flex;flex-direction:column;margin-bottom:10px;*{color:var(--color-brand-grey-main)!important;}"
} : 0);

var GeneryItemStyles =  true ? {
  name: "176bijj",
  styles: "color:var(--color-brand-grey-main)!important;line-height:20px"
} : 0;

var ItemLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "ed82sm63"
} : 0)(GeneryItemStyles, " font-weight:700;font-size:0.9375rem;&::after{content:\":\";}" + ( true ? "" : 0));

var ItemInfo = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "ed82sm62"
} : 0)(GeneryItemStyles, " font-weight:400;font-size:0.875rem;" + ( true ? "" : 0))));

var ItemRef = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((link_default()),  true ? {
  target: "ed82sm61"
} : 0)(GeneryItemStyles, " font-weight:500;font-size:0.835rem;a{color:var(--color-brand-grey-main)!important;}" + ( true ? "" : 0));

var CardContentSocialNetwork = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ed82sm60"
} : 0)( true ? {
  name: "1hh7mgd",
  styles: "margin-top:15px;display:flex;align-items:center;img{margin-right:10px;}"
} : 0);
// EXTERNAL MODULE: ./shared/components/custom-carrusel/index.tsx
var custom_carrusel = __webpack_require__(20518);
// EXTERNAL MODULE: ./shared/components/messages-result/index.tsx
var messages_result = __webpack_require__(52659);
;// CONCATENATED MODULE: ./shared/components/slider-agents-card-large/index.tsx





function slider_agents_card_large_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function slider_agents_card_large_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? slider_agents_card_large_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : slider_agents_card_large_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function slider_agents_card_large_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function SliderAgentsCardLarge(props) {
  var _data$data, _data$data2;

  var fetchProjectSlider = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0,agent_request/* getAgents */.j)(slider_agents_card_large_objectSpread({
                page: 1
              }, props.filters));

            case 2:
              response = _context.sent;
              return _context.abrupt("return", response);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProjectSlider() {
      return _ref.apply(this, arguments);
    };
  }();

  var _useMutation = (0,useMutation/* useMutation */.D)(["agents-slider"], fetchProjectSlider),
      data = _useMutation.data,
      status = _useMutation.status,
      isLoading = _useMutation.isLoading,
      isError = _useMutation.isError,
      mutate = _useMutation.mutate;

  (0,react.useEffect)(function () {
    mutate();
  }, [props.filters]);
  props.setHaveAgents(!!!data || !!(data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.length) ? true : false);

  if (data && (data === null || data === void 0 ? void 0 : (_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.length) == 0 && isLoading) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null);
  }

  if (isError) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(messages_result/* MessageResults */.s, {
      message: "Ha ocurrido un error"
    });
  }

  return (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(custom_carrusel/* default */.Z, {
    placeholderItem: (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SkeletonAgent, null))
  }, data === null || data === void 0 ? void 0 : data.data.map(function (item, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(Wrapper, {
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(agent_card_large, item));
  })));
}

/* harmony default export */ var slider_agents_card_large = (SliderAgentsCardLarge);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e5wqb5p4"
} : 0)( true ? {
  name: "jczsus",
  styles: "display:flex!important;justify-content:center;padding:10px 5px"
} : 0);

var SkeletonAgent = function SkeletonAgent() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      width: 270
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Photo, {
    variant: "rectangular"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Name, {
    variant: "rounded"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Text, {
    variant: "rounded",
    width: 210
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Text, {
    variant: "rounded",
    width: 220
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    style: {
      display: "flex"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Red, {
    variant: "circular"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Red, {
    variant: "circular"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Red, {
    variant: "circular"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Red, {
    variant: "circular"
  })));
};

var Photo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Skeleton/* default */.Z,  true ? {
  target: "e5wqb5p3"
} : 0)( true ? {
  name: "1cvxus1",
  styles: "width:270px;height:200px;border-radius:15px;margin-bottom:10px"
} : 0);

var Name = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Skeleton/* default */.Z,  true ? {
  target: "e5wqb5p2"
} : 0)( true ? {
  name: "1s8ptb4",
  styles: "width:260px;height:20px;margin-bottom:10px"
} : 0);

var Text = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Skeleton/* default */.Z,  true ? {
  target: "e5wqb5p1"
} : 0)( true ? {
  name: "10d8tor",
  styles: "height:20px;margin-bottom:10px"
} : 0);

var Red = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Skeleton/* default */.Z,  true ? {
  target: "e5wqb5p0"
} : 0)( true ? {
  name: "epj5fq",
  styles: "width:30px;height:30px;margin-right:30px"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agency-profile/components/sliders-section/index.tsx



function sliders_section_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function SliderSection(props) {
  var profileInfo = props.profileInfo,
      IsUserCollection = props.IsUserCollection;

  var _useState = (0,react.useState)(true),
      haveAgents = _useState[0],
      setHaveAgents = _useState[1];

  var translationAgent = (0,next_intl_cjs_production_min.useTranslations)("agencyProfile.agents");
  var translationProperties = (0,next_intl_cjs_production_min.useTranslations)("agencyProfile.properties");
  var translationCollection = (0,next_intl_cjs_production_min.useTranslations)("agencyProfile.collection");
  var collectionTitle = translationCollection("title") || "";

  var _collectionTitle$spli = collectionTitle.split(" "),
      _collectionTitle$spli2 = (0,toArray/* default */.Z)(_collectionTitle$spli),
      title = _collectionTitle$spli2[0],
      rest = _collectionTitle$spli2.slice(1);

  return (0,emotion_react_browser_esm/* jsx */.tZ)("div", null, haveAgents && (0,emotion_react_browser_esm/* jsx */.tZ)(WrapperContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, translationAgent("title")), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_agents_card_large, {
    setHaveAgents: setHaveAgents,
    filters: {
      agency: profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.id
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerBtn, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.agents_list */.K.es.agents_list + "?agency=".concat(profileInfo.id),
    passHref: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translationAgent("seeMore"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(WrapperContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(PropertiesSlider/* default */.Z, {
    title: translationProperties("title"),
    subtitle: "",
    filters: {},
    refRequest: "property-list-normal-query",
    detailPath: pages_path/* CPagesPath.es.property_detail */.K.es.property_detail
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerBtn, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.properties */.K.es.properties
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translationProperties("seeMore"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(WrapperContent, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Title, null, title, " ", (0,emotion_react_browser_esm/* jsx */.tZ)(TitleSpan, null, rest.join(" "))), (0,emotion_react_browser_esm/* jsx */.tZ)(slider_collection_property/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerBtn, null, (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: pages_path/* CPagesPath.es.collection_properties */.K.es.collection_properties
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    component: "a"
  }, translationCollection("seeMore"))))));
}

/* harmony default export */ var sliders_section = (SliderSection);

var ContainerBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fg3tse3"
} : 0)( true ? {
  name: "1n36c9n",
  styles: "width:100%;display:flex;justify-content:center;margin-bottom:50px;margin-top:30px"
} : 0);

var WrapperContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fg3tse2"
} : 0)( true ? {
  name: "1t4exv4",
  styles: "width:90%;margin:auto;& .collection__card__description{color:var(--color-brand-blue-main);span{color:var(--color-brand-blue-main);}}@media screen and (max-width: 991px){width:100%;}"
} : 0);

var Title = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e1fg3tse1"
} : 0)( true ? {
  name: "66s9sv",
  styles: "width:100%;text-align:center;text-transform:uppercase;font-size:1.9rem;margin-bottom:60px;margin-top:80px;color:var(--color-brand-blue-main)"
} : 0);

var TitleSpan = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1fg3tse0"
} : 0)( true ? {
  name: "1a0w822",
  styles: "font-weight:300"
} : 0);
;// CONCATENATED MODULE: ./shared/components-pages/profiles/agency-profile/index.tsx




function agency_profile_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }















function AgencyProfileContain(props) {
  var width = (0,use_width_hook/* useWidth */.z)();
  var router = (0,next_router.useRouter)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("agencyProfile");
  var agencyTitle = translation("title") || "";

  var _agencyTitle$split = agencyTitle.split(" "),
      _agencyTitle$split2 = (0,toArray/* default */.Z)(_agencyTitle$split),
      title = _agencyTitle$split2[0],
      rest = _agencyTitle$split2.slice(1);

  var _useSessionStorage = (0,esm/* useSessionStorage */.Xs)("code", {
    id: null,
    type: null
  }),
      _useSessionStorage2 = (0,slicedToArray/* default */.Z)(_useSessionStorage, 2),
      code = _useSessionStorage2[0],
      setCode = _useSessionStorage2[1];

  var translationProfile = (0,next_intl_cjs_production_min.useTranslations)("agencyProfile.profile");

  var _useState = (0,react.useState)(adapterAgent(null)),
      profileInfo = _useState[0],
      setProfileInfo = _useState[1];

  (0,react.useEffect)(function () {
    setProfileInfo(adapterAgent(props.data.data));
    var agencyCode = {
      type: "areferer",
      id: props.id
    };
    setCode(agencyCode);
    var url = "/agencia/".concat(props.data.data.name.replaceAll(" ", "-").replace("re max", "RE/MAX").replace("/", "-").toLowerCase(), "/").concat(props.data.data.id, "?areferer=").concat(props.id);
    router.replace(url, undefined, {
      shallow: true
    });
  }, []);
  var config = {
    profileInfo: profileInfo
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Content, null, (0,emotion_react_browser_esm/* jsx */.tZ)(header_title_profile/* default */.Z, {
    label: rest.join(" "),
    title: title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Card, null, (0,emotion_react_browser_esm/* jsx */.tZ)(CardContainer, {
    className: "container"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Thumbnail, {
    src: profileInfo.picture
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentDetail, null, !["xs", "sm"].includes(width) && (0,emotion_react_browser_esm/* jsx */.tZ)(LabelNameAgency, null, profileInfo.name), (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_ContentInfo, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentInfoItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Info, {
    className: "--title"
  }, "Br\xF3ker(s)"), (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Info, {
    className: "--description"
  }, profileInfo.brokers)), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentInfoItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Info, {
    className: "--title"
  }, translationProfile("email")), (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Info, {
    className: "--description"
  }, profileInfo.email)), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentInfoItem, null, (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Info, {
    className: "--title"
  }, translationProfile("address")), (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile_Info, {
    className: "--description"
  }, profileInfo.address)))), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_section, {
    profileInfo: profileInfo,
    isAgency: true
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(FilterContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(buy_sell_filter/* default */.Z, {
    redirect: pages_path/* CPagesPath.es.properties */.K.es.properties
  }))), (0,emotion_react_browser_esm/* jsx */.tZ)(sliders_section, config));
}

var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1a3au8910"
} : 0)( true ? {
  name: "w4qr9k",
  styles: "margin-top:100px;@media screen and (max-width: 767px){margin-top:60px;}"
} : 0);

var agency_profile_Card = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1a3au899"
} : 0)( true ? {
  name: "19d95gz",
  styles: "padding-top:50px;padding-bottom:80px;background-color:#fff;@media screen and (max-width: 767px){padding-bottom:0px;}@media screen and (max-width: 450px){padding-top:10px;}"
} : 0);

var FilterContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1a3au898"
} : 0)( true ? {
  name: "w4v749",
  styles: "width:100%;margin:auto;display:flex;margin-top:30px;& .content-body{background:#F7F6F4;.MuiInputBase-root{background:#F7F6F4;}}"
} : 0);

var CardContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1a3au897"
} : 0)( true ? {
  name: "861p4a",
  styles: "display:flex;flex-wrap:wrap;border-bottom:1px solid #CBCBCB;padding-bottom:50px;@media screen and (max-width: 991px){justify-content:space-between;}@media screen and (max-width: 767px){flex-direction:column;&.container{padding-bottom:0;}}"
} : 0);

var Thumbnail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1a3au896"
} : 0)( true ? {
  name: "1hki3rq",
  styles: "width:263px;height:263px;border-radius:50%;margin-right:40px;background-position:center;background-size:cover;background-repeat:no-repeat;background:white;object-fit:contain;@media screen and (max-width: 991px){margin-right:0;}@media screen and (max-width: 899px){height:auto;margin:0 auto;border-radius:0;}"
} : 0);

var ContactDetail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1a3au895"
} : 0)( true ? {
  name: "1ms4ujr",
  styles: "height:100%;@media screen and (max-width: 991px){width:30%;margin-right:0;}@media screen and (max-width: 767px){width:100%;margin:0 auto 30px;display:flex;flex-direction:column;align-items:center;}"
} : 0);

var ContentDetail = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1a3au894"
} : 0)( true ? {
  name: "lsc2y7",
  styles: "height:100%;@media screen and (max-width: 991px){width:60%;margin-right:0;}@media screen and (max-width: 767px){width:100%;margin:0 auto 30px;display:flex;flex-direction:column;align-items:center;}"
} : 0);

var LabelNameAgency = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1a3au893"
} : 0)( true ? {
  name: "q4ccj3",
  styles: "font-size:2.188rem;font-weight:700;text-align:left;margin:15px 0;text-transform:uppercase;color:var(--color-brand-blue-main);span{font-weight:300;}@media screen and (max-width: 767px){text-align:center;margin-bottom:30px;font-size:1.788rem;}"
} : 0);

var agency_profile_ContentInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1a3au892"
} : 0)( true ? {
  name: "1sd9whr",
  styles: "list-style:none;@media screen and (max-width: 767px){margin-bottom:20px;}"
} : 0);

var ContentInfoItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1a3au891"
} : 0)( true ? {
  name: "avpsk8",
  styles: "margin-bottom:15px"
} : 0);

var agency_profile_Info = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1a3au890"
} : 0)( true ? {
  name: "fqvo17",
  styles: "display:block;font-size:1.063rem;font-weight:500;color:var(--color-brand-blue-main);max-width:450px;&.--description{color:var(--color-brand-grey-secondary);}"
} : 0);

/* harmony default export */ var agency_profile = (AgencyProfileContain);

var adapterAgent = function adapterAgent(data) {
  var _data$id, _data$name, _data$agency_name, _data$phone, _data$address, _data$email, _data$logo;

  var brokers = "";

  if (data != null && data.brokers != null) {
    brokers = data.brokers.map(function (x) {
      return x.broker_name;
    }).join(", ");
  }

  return {
    id: (_data$id = data === null || data === void 0 ? void 0 : data.id) !== null && _data$id !== void 0 ? _data$id : null,
    name: (_data$name = data === null || data === void 0 ? void 0 : data.name) !== null && _data$name !== void 0 ? _data$name : "-",
    agency_name: (_data$agency_name = data === null || data === void 0 ? void 0 : data.agency_name) !== null && _data$agency_name !== void 0 ? _data$agency_name : "-",
    phone: (_data$phone = data === null || data === void 0 ? void 0 : data.phone) !== null && _data$phone !== void 0 ? _data$phone : "-",
    address: (_data$address = data === null || data === void 0 ? void 0 : data.address) !== null && _data$address !== void 0 ? _data$address : "-",
    email: (_data$email = data === null || data === void 0 ? void 0 : data.email) !== null && _data$email !== void 0 ? _data$email : "-",
    picture: (_data$logo = data === null || data === void 0 ? void 0 : data.logo) !== null && _data$logo !== void 0 ? _data$logo : placeholder_images_const/* AgencyPicPlaceholder */.bV,
    brokers: brokers
  };
};
// EXTERNAL MODULE: ./shared/models/functions/removeparams.ts
var removeparams = __webpack_require__(57626);
;// CONCATENATED MODULE: ./pages/agencia/[...params].tsx









var Agencia = function Agencia(props) {
  var _useSessionStorage = (0,esm/* useSessionStorage */.Xs)("code", {
    id: null,
    type: null
  }),
      _useSessionStorage2 = (0,slicedToArray/* default */.Z)(_useSessionStorage, 2),
      code = _useSessionStorage2[0],
      setCode = _useSessionStorage2[1];

  var router = (0,next_router.useRouter)();
  var configProfile = {
    id: props.id,
    data: props.data
  };
  var metaData = {
    description: "Agencia inmobiliaria ".concat(props.data.data.name, " C\xF3digo ").concat(props.id),
    keyWords: "Agencia inmobiliaria, Agencia inmobiliaria remax rd, Agencia Remax, Remax agencia inmobiliaria, Agencia Remax República Dominicana",
    url: "https://remaxrd.com" + router.asPath,
    type: "Agencia RE/MAX ".concat(props.data.data.name),
    title: "Agencia ".concat(props.data.data.name.toUpperCase(), " ")
  };
  react.useEffect(function () {
    setCode({
      id: props.id,
      type: "areferer"
    });
    router.push(router.asPath, undefined, {
      shallow: true
    });
  }, []);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)((head_default()), null, (0,emotion_react_browser_esm/* jsx */.tZ)("title", null, metaData.title), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "description",
    content: metaData.description
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:url",
    content: metaData.url
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:type",
    content: metaData.type
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:title",
    content: metaData.title
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    property: "og:image",
    content: props.data.data.picture
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("meta", {
    name: "keywords",
    content: metaData.keyWords
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("link", {
    rel: "canonical",
    href: (0,removeparams/* default */.Z)(metaData.url),
    key: "canonical"
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(agency_profile, configProfile));
};

var __N_SSP = true;
/* harmony default export */ var _params_ = (Agencia);

/***/ }),

/***/ 50408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _titles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23814);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





function HeaderTitleProfile(props) {
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ContainerTitle, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_titles__WEBPACK_IMPORTED_MODULE_2__/* .TitleThickThin */ .U, {
    thickTitle: props.title || "",
    thinTitle: props.label
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (HeaderTitleProfile);

var ContainerTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("article",  true ? {
  target: "e1du7pdd0"
} : 0)( true ? {
  name: "1xx0702",
  styles: "height:100px;display:flex;justify-content:center;align-items:center;flex-direction:column;& h2{margin:0!important;}"
} : 0);

/***/ }),

/***/ 23814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ titles_TitleThickThin; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(37337);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/titles/TitleThickThin.tsx



var _templateObject;

var _excluded = ["component", "align", "fw", "color", "fs", "mb"];




var TitleThickThin = function TitleThickThin(props) {
  var _props$component = props.component,
      component = _props$component === void 0 ? "h2" : _props$component,
      _props$align = props.align,
      align = _props$align === void 0 ? "center" : _props$align,
      _props$fw = props.fw,
      fw = _props$fw === void 0 ? 600 : _props$fw,
      _props$color = props.color,
      color = _props$color === void 0 ? "--color-text-black" : _props$color,
      _props$fs = props.fs,
      fs = _props$fs === void 0 ? "--fs-sub-title-large" : _props$fs,
      _props$mb = props.mb,
      mb = _props$mb === void 0 ? "60px" : _props$mb,
      rest = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var Title = emotion_styled_browser_esm/* default */.Z[component](_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    margin: auto;\n    font-family: var(--font-family);\n    font-size: 27.2px;\n    font-weight: ", ";\n    line-height: 21px;\n    letter-spacing: 0px;\n    color: var(", ");\n    text-align: ", ";\n    margin-bottom:", " !important;\n    & span{\n      font-weight: 400;\n      font-family: var(--font-family);\n    }\n  "])), fw, color, align, mb);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Title, {
    className: props.titleClass
  }, props.thickTitle, " ", (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
    className: props.thickTitle
  }, props.thinTitle));
};

/* harmony default export */ var titles_TitleThickThin = (TitleThickThin);
;// CONCATENATED MODULE: ./shared/components/titles/index.tsx



/***/ }),

/***/ 72020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bV": function() { return /* binding */ AgencyPicPlaceholder; }
/* harmony export */ });
/* unused harmony exports AgentPicPlaceholder, propertyPicPlaceholder */
var AgencyPicPlaceholder = '/icons/remax-balloon.png';
var AgentPicPlaceholder = '/icons/remax-balloon.png';
var propertyPicPlaceholder = '/icons/remax-balloon.png';

/***/ }),

/***/ 99547:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agencia/[...params]",
      function () {
        return __webpack_require__(71986);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,8584,8360,2966,2203,6869,3405,8654,9470,4003,1691,2098,2737,7814,9774,2888,179], function() { return __webpack_exec__(99547); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);